export default "__VITE_ASSET__11065bad__"